import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers';
import { BlackListEntity } from '../models';

@Injectable()
export class BlackListService {
  private url: string;
  constructor(private httpClient: HttpClient, @Inject('API_URL') private apiUrl: string) {
    this.url = apiUrl + 'blackList/';
  }

  checkBlackList(entity: BlackListEntity): Observable<any> {
    entity.requestDate = this.dateToISOLikeButLocal(new Date());
    const url: string = this.url + 'checkBlackList';
    const response: Observable<any> = this.httpClient.post<any>(url, entity , {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  blackListReport(entity: BlackListEntity): Observable<any> {
    entity.requestDate = this.dateToISOLikeButLocal(new Date());
    const url: string = this.url + 'blackListView';
    const response: Observable<any> = this.httpClient.post<any>(url, entity , {
      responseType: 'blob' as 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  blackListReportbyId(id: number, entityType: number){
    const url: string = this.url + 'blackListReport/' + id + '/' + entityType;
    const response: Observable<any> = this.httpClient.get<any>(url , {
      responseType: 'blob' as 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  dateToISOLikeButLocal(date: Date): string {
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    const msLocal = date.getTime() - offsetMs;
    const dateLocal = new Date(msLocal);
    const iso = dateLocal.toISOString();
    const isoLocal = iso.slice(0, 19);
    return isoLocal;
  }
  
}